export enum AuthorityAccountPayable {
  FINANCIAL_ACCOUNT_PAYABLE_INSTALLMENTS_SETTLEMENT = '3.1.6',
  FINANCIAL_ACCOUNT_PAYABLE_INSTALLMENTS_DELETE = '3.1.4',
  FINANCIAL_ACCOUNT_PAYABLE_INSTALLMENTS_ADD = '3.1.3',
  FINANCIAL_ACCOUNT_PAYABLE_INSTALLMENTS_VIEW = '3.1.2',
  FINANCIAL_ACCOUNT_PAYABLE_INSTALLMENTS_LAUNCH = '3.1',
  FINANCIAL_ACCOUNT_PAYABLE_REFUND_INSTALLMENTS_PAYABLE = '3.1.9',
  FINANCIAL_ACCOUNT_PAYABLE_SETTLE_REFUND_WITH_PREVIOUS_DATE = '3.1.8',
  FINANCIAL_ACCOUNT_PAYABLE_EDIT_DATE_SETTLE_INSTALLMENT = '3.1.6.1',
  FINANCIAL_ACCOUNT_PAYABLE_EDIT = '3.1.7',
  FINANCIAL_ACCOUNT_PAYABLE_GROUP_ACCOUNTS_PAYABLE = '3.3.1',
  FINANCIAL_ACCOUNT_PAYABLE_GROUP_OF_ACCOUNTS_PAYABLE = '3.3',
  FINANCIAL_ACCOUNT_PAYABLE_GENERATE_ACCOUNTS_PAYABLE = '3.2.6',
  FINANCIAL_ACCOUNT_PAYABLE_EDIT_FORECAST_OF_ACCOUNTS_PAYABLE = '3.2.4',
  FINANCIAL_ACCOUNT_PAYABLE_DELETE_FORECAST_OF_ACCOUNTS_PAYABLE = '3.2.3',
  FINANCIAL_ACCOUNT_PAYABLE_ADD_FORECAST_OF_ACCOUNTS_PAYABLE = '3.2.2',
  FINANCIAL_ACCOUNT_PAYABLE_VIEW_FORECAST_OF_ACCOUNTS_PAYABLE = '3.2.1',
  FINANCIAL_ACCOUNT_PAYABLE_FORECAST_OF_ACCOUNTS_PAYABLE = '3.2',
  FINANCIAL_ACCOUNT_PAYABLE_FINANCIAL = '3.',
}
